import { atom } from "recoil";

export const prevSelectedClientState = atom({
  key: "prevSelectedClientState",
  default: null,
});

export enum ProductCategoryType {
  PRODUCT="product",
  MATERIAL="material",
  CUSTOMER_SKU="customerSku",
}

export const isCustomerSkuProduct = (item: any): boolean =>
  item?.isCustomerSKU === true ||
  item?.category === ProductCategoryType.CUSTOMER_SKU;

export const mapProductToQuoteTreeNode = (product: any) => {
  const isCustomerSku = isCustomerSkuProduct(product);
  const name = product.name || "";
  const code = product.code || product.Code || "";
  const serialNumber = String(
    product.serialNumber || product.SerialNumber || ""
  ).trim();
  const displayTitle = isCustomerSku
    ? serialNumber
      ? name
        ? `${serialNumber} - ${name}`
        : serialNumber
      : code
        ? `${code} - ${name}`
        : name
    : name;
  return {
    value: product.id,
    title: displayTitle,
    text: name,
    code,
    serialNumber,
    level: 1,
    isLeaf: true,
    selectable: true,
    category: isCustomerSku
      ? ProductCategoryType.CUSTOMER_SKU
      : ProductCategoryType.PRODUCT,
    sku: isCustomerSku ? product.name || product.sku : undefined,
    productId: product.id,
    boardMissionId: product.boardMissionId || product.BoardMissionId,
    orderItemId: product.orderItemId || product.OrderItemId,
    skuGroupName:
      product.skuGroupName ||
      product.SkuGroupName ||
      product.SKUGroupName ||
      (isCustomerSku ? product.code || product.Code : "") ||
      "",
    price: product.price ?? product.unitPrice,
    quantity: product.quantity,
    isCustomerSKU: isCustomerSku,
  };
};

export const buildSelectedQuoteProduct = (
  selectedNode: any,
  matchedProduct: any,
  selectedValue: any
) => {
  const isCustomerSku =
    isCustomerSkuProduct(selectedNode) || isCustomerSkuProduct(matchedProduct);
  const productId =
    selectedNode?.productId || matchedProduct?.id || selectedValue;
  return {
    id: productId,
    treeValue: selectedValue,
    category: isCustomerSku
      ? ProductCategoryType.CUSTOMER_SKU
      : selectedNode?.category,
    name: selectedNode?.text || matchedProduct?.name,
    code: selectedNode?.code || matchedProduct?.code,
    sku:
      selectedNode?.sku ||
      (isCustomerSku
        ? selectedNode?.text || matchedProduct?.name
        : undefined),
    productStructureType: matchedProduct?.productStructureType,
    isEmptyProduct: matchedProduct?.isEmptyProduct,
    isMaterial: matchedProduct?.isMaterial,
    boardMissionId:
      selectedNode?.boardMissionId ||
      matchedProduct?.boardMissionId ||
      matchedProduct?.BoardMissionId,
    orderItemId:
      selectedNode?.orderItemId ||
      matchedProduct?.orderItemId ||
      matchedProduct?.OrderItemId,
    skuGroupName:
      selectedNode?.skuGroupName ||
      matchedProduct?.skuGroupName ||
      (isCustomerSku
        ? selectedNode?.code || matchedProduct?.code
        : "") ||
      "",
    price: selectedNode?.price ?? matchedProduct?.price,
    quantity: selectedNode?.quantity ?? matchedProduct?.quantity,
    productId,
    isCustomerSKU: isCustomerSku,
  };
};
